import classNames from 'classnames'
import { useCallback, useEffect, useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import { useSnippets } from '../../hooks/_useSnippets'
import useVisitNotesContext from '../../hooks/useVisitNotesContext'
import { VisitNote } from '../../services/models/VisitNote.model'

const Styles = styled.div`
    textarea {
        white-space: pre-line;
        resize: none;
    }
`

interface Props {
    className?: string
    visitNote: VisitNote
}

export const NoteEditor = ({ className, visitNote }: Props) => {
    const { updateVisitNoteContent } = useVisitNotesContext().visitNotes
    const [content, setContent] = useState<string>(visitNote.content || '')
    const { applySnippetHandler } = useSnippets()
    useEffect(() => setContent(visitNote.content || ''), [visitNote.content])

    const onUpdate = useCallback(
        (_content: string) => {
            updateVisitNoteContent(visitNote._id, _content).catch(
                (error: any) => {
                    console.error(error)
                    toast.error('Error updating note')
                }
            )
        },
        [visitNote._id, updateVisitNoteContent]
    )

    const onChangeHandler = useCallback(
        (str: string) => {
            const snippet = applySnippetHandler(str)

            if (snippet) {
                setContent(snippet)
                return
            }
            setContent(str)
        },
        [applySnippetHandler]
    )

    return (
        <Styles className={classNames(className)}>
            <TextareaAutosize
                name="visit-note"
                className="w-full"
                value={content}
                onChange={(event) => onChangeHandler(event.target.value)}
                onBlur={(event) => onUpdate(event.target.value)}
                readOnly={VisitNote.isProcessing(visitNote)}
            />
        </Styles>
    )
}
